import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getVideoCommentsCounts_v2, getVideoZanCounts, videoDianZan } from '../../base/getVideoInfo';

export default class CommentsAndZan extends PureComponent {
    static propTypes = {
        vid: PropTypes.string.isRequired,
        clickComments: PropTypes.func.isRequired,
    };

    hasDianZan = false;

    state = {
        allow_comment: -1,
        commentsNum: 0,
        zanNum: 0,
    };

    getVideoZanNums = async vid => {
        const getZanNum = await getVideoZanCounts(vid);

        if (getZanNum && getZanNum.code) {
            this.setState({
                zanNum: (getZanNum.data && getZanNum.data.browse && getZanNum.data.browse[`${vid}ding`]) || 0,
            });
        }
    };

    handleClickComments = () => {
        const { clickComments } = this.props;

        if (clickComments && typeof clickComments === 'function') {
            clickComments();
        }
    };

    handleDianZan = async () => {
        const { vid } = this.props;

        if (!this.hasDianZan) {
            const dianZan = await videoDianZan(vid);

            if (dianZan && dianZan.code) {
                this.setState({
                    zanNum: this.state.zanNum + 1,
                });
                this.hasDianZan = true;
            }
        }
    };

    asyncGetData = async vid => {

        const { commentUrl } = this.props; // 接收视频传递数据

        const getComments = await getVideoCommentsCounts_v2(commentUrl);

        this.setState({
            vid,
            allow_comment: getComments && getComments.allow_comment,
            commentsNum: (getComments && getComments.count) || 0,
        });
        await this.getVideoZanNums(vid);
    };

    componentDidUpdate(prevProps) {
        // 处理视频切换时重新请求评论点赞数
        if (this.props.vid !== prevProps.vid) {
            this.asyncGetData(this.props.vid);
        }
    }

    componentDidMount() {
        this.asyncGetData(this.props.vid);
    }

    render() {
        const { commentsNum, zanNum, allow_comment } = this.state;

        return (
            <div className={styles.vFeed}>
                {allow_comment !== -1 ? (
                    <div className={styles.vComment}>
                        <a href="javascript:;" title="评论" onClick={this.handleClickComments}>
                            <em id="js_ping">{commentsNum}</em>
                        </a>
                    </div>
                ) : null}
                <div className={styles.vDingCai}>
                    <div className={styles.vDing} title="顶">
                        <a href="javascript:;" onClick={this.handleDianZan}>
                            <em id="js_supportCount">{zanNum}</em>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}
